<template>
  <section class="comparisons__container">
    <h2>Сравнение с другими решениями</h2>

    <div class="comparisons__wrapper">
      <div class="comparisons__table">
        <div class="comparisons__table-header">
          <div class="comparisons__table-cell comparisons__table-title">&nbsp;</div>
          <div class="comparisons__table-cell">Расширенная коллаборация</div>
          <div class="comparisons__table-cell">Полнофункциональные текст и таблица</div>
          <div class="comparisons__table-cell">Простой интерфейс</div>
          <div class="comparisons__table-cell">Низкие требования к ресурсам</div>
          <div class="comparisons__table-cell">Закрытый контур</div>
          <div class="comparisons__table-cell">Риск блокировки в РФ</div>
        </div>
        <div ref="body" class="comparisons__table-body">
          <div class="comparisons__table-body-content" :style="{ transform: `translateX(-${this.scrollX}px)` }">
            <div v-for="(row, key) in table" :key="key" class="comparisons__table-column">
              <div class="comparisons__table-cell comparisons__table-title">{{ row.title }}</div>
              <div v-for="(feature, index) in row.features" :key="index"
                   class="comparisons__table-cell comparisons__table-feature" :class="{ checked: feature === 1 }">
                <inline-svg v-if="feature >= 0" class="comparisons__table-cell--icon"
                            :src="`/images/v4/svg/${feature ? 'icon-checkmark' : 'icon-cross'}.svg`" />
                <span v-else>{{ feature === -1 ? '&nbsp;' : 'ДА' }}</span>
              </div>
            </div>
          </div>
          <div ref="scroll" class="comparisons__table-body-scroll" @scroll="onScroll">
            <div class="comparisons__table-body-scroll-inner" />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Comparisons',
  data() {
    return {
      scrollX: 0,
      table: [{
        title: 'Coverse',
        features: [1, 1, 1, 1, 1, -1],
      }, {
        title: 'Яндекс.Документы',
        features: [1, 1, 1, 0, 0, -1],
      }, {
        title: 'Mail.ru',
        features: [0, 1, 0, 0, 0, -1],
      }, {
        title: 'VK Workspace',
        features: [0, 1, 0, 0, 1, -1],
      }, {
        title: 'МойОфис',
        features: [0, 1, 0, 0, 1, -1],
      }, {
        title: 'Google',
        features: [1, 1, 1, 1, 0, -2],
      }],
    }
  },
  methods: {
    onScroll() {
      this.scrollX = this.$refs.scroll.scrollLeft;
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/breakpoints";

.comparisons__container {
  margin: 0 0 70px;

  h2 {
    font-size: 40px;
    font-weight: 700;
    line-height: 40px;
    text-align: center;
    margin: 0 0 45px;
  }

  .comparisons__wrapper {
    max-width: 1000px;
    margin: 0 auto;
  }

  .comparisons__table {
    display: flex;
    width: 100%;
    overflow: hidden;

    .comparisons__table-header {
      display: flex;
      flex-direction: column;
      gap: 10px;
      flex: 1 0 auto;
      max-width: 352px;
      padding-bottom: 20px;

      .comparisons__table-cell {
        flex: 1;
        display: flex;
        align-items: center;
        min-height: 40px;
        font-size: 14px;
        font-weight: 600;
        line-height: 40px;
        background-color: #F1F1F1;
        padding: 0 0 0 19px;
        border-top-left-radius: 6px;
        border-bottom-left-radius: 6px;

        &.comparisons__table-title {
          background-color: transparent;
        }
      }
    }

    .comparisons__table-body {
      position: relative;
      display: flex;
      overflow: hidden;
      padding-bottom: 20px;

      .comparisons__table-body-content {
        flex: 1 0 auto;
        width: 645px;
        display: flex;
      }

      .comparisons__table-column {
        display: flex;
        flex-direction: column;
        gap: 10px;
        flex: 1 0 auto;

        .comparisons__table-cell {
          flex: 1;
          min-height: 40px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 14px;
          font-weight: 700;
          background-color: #F1F1F1;
          color: #FC656F;

          &.checked {
            color: #58D682;
          }

          .comparisons__table-cell--icon {
            width: 20px;
            height: 20px;
            fill: currentColor;
          }

          &.comparisons__table-title {
            align-items: flex-end;
            background-color: transparent;
            color: #333334;
          }
        }

        &:last-of-type {
          .comparisons__table-cell {
            border-top-right-radius: 6px;
            border-bottom-right-radius: 6px;
          }
        }
      }
    }

    .comparisons__table-body-scroll {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 100%;
      overflow: auto;

      .comparisons__table-body-scroll-inner {
        width: 645px;
        height: 100%;
      }
    }
  }
}

@include media-breakpoint-down($size-tablet) {
  .comparisons__container {
    padding: 0 30px;
    margin: 0 0 50px;

    h2 {
      font-size: 34px;
      margin: 0 0 38px;
    }
  }
}

@include media-breakpoint-down($size-mobile) {
  .comparisons__container {
    padding: 0 20px;
    margin: 0 0 37px;

    h2 {
      font-size: 24px;
      line-height: 34px;
      margin: 0 0 29px;
    }

    .comparisons__table {
      .comparisons__table-header {
        max-width: 190px;
        .comparisons__table-cell {
          padding: 10px 0 10px 11px;
          line-height: 22px;
        }
      }
    }
  }
}
</style>
